<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <h6 class="oxd-text--h6">Export personalizzato</h6>

      <form @submit.prevent="exportExcel">
        <div class="oxd-form-row">
          <label class="oxd-label">Progetto</label>
          <input
            v-model="projectId"
            class="oxd-input oxd-input--active"
            placeholder="ID progetto"
          />
        </div>

        <div class="oxd-form-row">
          <label class="oxd-label">Dipendente</label>
          <input
            v-model="employeeId"
            class="oxd-input oxd-input--active"
            placeholder="Employee #"
          />
        </div>

        <div class="oxd-form-row">
          <label class="oxd-label">Da</label>
          <input
            v-model="from"
            type="date"
            class="oxd-input oxd-input--active"
          />
          <label class="oxd-label" style="margin-left: 0.75rem">A</label>
          <input v-model="to" type="date" class="oxd-input oxd-input--active" />
        </div>

        <div class="oxd-form-row">
          <label class="oxd-switch-wrapper">
            <input
              v-model="approvedOnly"
              type="checkbox"
              class="oxd-switch-input"
            />
            <span class="oxd-switch"></span>
            <span style="margin-left: 0.5rem">Solo timesheet approvati</span>
          </label>
        </div>

        <div class="oxd-form-actions">
          <button class="oxd-button oxd-button--main" type="submit">
            Esporta Excel
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomExportReport',
  data() {
    return {
      projectId: '',
      employeeId: '',
      from: '',
      to: '',
      approvedOnly: false,
    };
  },
  methods: {
    exportExcel() {
      const qs = new URLSearchParams({
        projectId: this.projectId || '',
        employeeId: this.employeeId || '',
        from: this.from || '',
        to: this.to || '',
        approvedOnly: this.approvedOnly ? '1' : '0',
      }).toString();
      window.location.href = `/time/custom-export.xlsx?${qs}`;
    },
  },
};
</script>
